import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import Logo from '../images/sfm-logo.svg';
import './Navbar.css';
function Navbar() {
    const [isSticky, setIsSticky] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
          const scrollTop = window.scrollY;
          // Adjust the threshold (e.g., 100) based on your desired sticky behavior
          setIsSticky(scrollTop > 100);
        };
      
        window.addEventListener('scroll', handleScroll);
      
        // Cleanup function to remove the event listener on component unmount
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);
      const [currentSection, setCurrentSection] = useState("");

        useEffect(() => {
            const handleScroll = () => {
            const sections = document.querySelectorAll("section[id]");
            let current = "";

            sections.forEach((section) => {
                const sectionTop = section.offsetTop;
                const sectionHeight = section.clientHeight;

                if (window.pageYOffset >= sectionTop - sectionHeight / 3) {
                current = section.getAttribute("id");
                }
            });

            setCurrentSection(current);
            };

            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []); // Empty array ensures effect is only run on mount and unmount
    return(
        <>
            <nav className={`navbar navbar-expand-sm innovly-navbar ${isSticky ? 'sticky' : ''}`}>
                <div class="container">
                <Link class="navbar-brand" to="/"><img src={Logo} alt="Logo"/></Link>
                <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div class="collapse navbar-collapse" id="collapsibleNavbar">
                    <ul class="navbar-nav ms-auto">
                        <li class="nav-item">
                        <a  className={`nav-link ${currentSection === "home" ? "active" : ""}`} href="/#home">Home</a>
                        </li>
                        <li class="nav-item">
                        <a  className={`nav-link ${currentSection === "products" ? "active" : ""}`} href="/#products">Products</a>
                        </li>
                        <li class="nav-item">
                        <a className={`nav-link ${currentSection === "contact" ? "active" : ""}`} href="/#contact">Contact us</a>
                        </li>
                    </ul>
                    </div>
                </div>
            </nav>
        </>
    );
}
export default Navbar;